import CrudService from "../core/crud-service";

export default class RelatedSpacesService extends CrudService {
  static route = "api/v1/related-spaces";

  async list() {
    return await this.httpService.get<any>(`${this.path}/list`);
  }
}
